import { Component, OnInit, inject, signal } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UserService } from 'src/app/shared/services/user/user.service';

@Component({
  selector: 'app-import-gateways-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title>Import Gateways from building</h2>
    <mat-dialog-content>
      <form [formGroup]="form" class="import-gateways-form">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Building</mat-label>
          <mat-select formControlName="buildingId" required>
            @for (building of buildings(); track building.id) {
              <mat-option [value]="building.id">{{ building.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onImport()" [disabled]="form.invalid || loading()">
        {{ loading() ? 'Importing...' : 'Import' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .import-gateways-form {
        min-width: 320px;
      }
      .w-full {
        width: 100%;
      }
    `
  ],
  imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule]
})
export class ImportGatewaysDialogComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly userService = inject(UserService);
  private readonly dialogRef = inject(MatDialogRef<ImportGatewaysDialogComponent>);

  readonly form: FormGroup = this.fb.group({
      buildingId: [null, Validators.required]
    });
  readonly buildings = signal<{ id: number; name: string }[]>([]);
  readonly loading = signal(false);

  ngOnInit(): void {
    this.loading.set(true);
    this.userService.getBuildingIdsWithNames().subscribe({
      next: (list) => {
        this.buildings.set(list ?? []);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.dialogRef.close(); // fail fast
        alert('Could not load buildings.');
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onImport(): void {
    if (this.form.valid) {
      const buildingId = this.form.value.buildingId as number;
      this.dialogRef.close(buildingId);
    }
  }
}
